import { useQuery } from '@tanstack/react-query';
import { AutocompleteElement, useFormContext } from 'react-hook-form-mui';

import Api from '@barboxx/api';
import { Business } from '@barboxx/models/types';

interface Props {
    disabled?: boolean;
}

type BusinessResult = Business.SearchResponse['results'][number];

interface BusinessWatchProps {
    business?: BusinessResult;
    businessId?: number | null;
}

export function BusinessInput({ disabled = false }: Props) {
    const { business } = useFormContext<BusinessWatchProps>().getValues();

    const businesstQueryResult = useQuery({
        queryKey: ['businesses'],
        queryFn: () =>
            Api.Businesses.getBusinesses({
                page: 0,
                size: 1000,
                sort: 'name,asc',
            }),
        initialData: {
            ok: true,
            problem: null,
            originalError: null,
            data: {
                results: business ? [business] : [],
                total: 1,
                isPaginated: false,
            },
        },
    });

    return (
        <AutocompleteElement
            label="Business"
            name="businessId"
            loading={businesstQueryResult.isLoading}
            multiple={false}
            options={businesstQueryResult.data?.data?.results ?? []}
            transform={{
                output(event, value, reason, details) {
                    if (reason === 'selectOption') {
                        return typeof value === 'string' ? value : value?.id;
                    }
                    if (reason === 'removeOption') {
                        return null;
                    }
                    return value;
                },
            }}
            autocompleteProps={{
                fullWidth: true,
                readOnly: disabled,
                disabled: disabled,
                isOptionEqualToValue(
                    option?: BusinessResult,
                    value?: BusinessResult | number | null
                ) {
                    const isNumber = typeof value === 'number';

                    if (isNumber) {
                        return option?.id === value;
                    } else {
                        return option?.id === (value?.id ?? value);
                    }
                },
                getOptionLabel(option) {
                    if (typeof option === 'string') {
                        return option;
                    }
                    return `${option?.place.name}`;
                },
                getOptionKey(option) {
                    if (typeof option === 'string') {
                        return option;
                    }
                    return `${option?.id}`;
                },
            }}
        />
    );
}
